/**
 * Which simulators are being dragged right now.
 *
 * The marker layer records every position change as track history, which is
 * correct for an aircraft that flew there and wrong for one an operator picked
 * up and put down: dragging three sims across an AOR drew three long blue
 * flight paths across the map for journeys nothing ever made.
 *
 * A module-level set rather than a parameter because the two sides are wired
 * independently — the drag hook lives on a view, the track lives in the marker
 * layer, and neither holds a handle to the other. Nothing here is reactive; it
 * is read synchronously inside a position update.
 */

const dragging = new Set<string>();

export function beginReposition(droneIds: readonly string[]): void {
  for (const droneId of droneIds) dragging.add(droneId);
}

export function endReposition(droneIds: readonly string[]): void {
  for (const droneId of droneIds) dragging.delete(droneId);
}

/** True while this aircraft is being placed by hand rather than flying. */
export function isRepositioning(droneId: string): boolean {
  return dragging.has(droneId);
}
